import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from './Text'

const CardHeading = ({ title, desc, noMargin = false }) => {
  return (
    <Stack sx={!noMargin ? { mb: { xs: 2, md: 3 } } : {}}>
      <Text label={title} color='inherit' variant='h6' />
      {desc && <Text variant='body2' label={desc} color='text.secondary' />}
    </Stack>
  )
}

export default memo(CardHeading)
